import { Subject } from 'rxjs';

class ActionService {
  private actions$ = new Subject();

  publishAction(action: any) {
    this.actions$.next(action);
  }

  getActions() {
    return this.actions$.asObservable();
  }
}

const actionService = new ActionService();
export default actionService;
